<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'WEBSITE.theme.background.title' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-margin" expand="block" color="medium" fill="clear" type="button" (click)="presentWebsitePreivewModal()">
        {{ 'BTN.preview' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="light" #content>
  <ion-grid class="full-width" *ngIf="width && height" #grid fixed>
    <ion-row class="ion-justify-content-between">
      <ion-col class="ion-align-self-center">
        <ion-card class="theme-card box-shadow ion-text-center" [style.width.px]="width" [style.height.px]="height" color="grey" (click)="select()" button>
          <div class="full-width-height vertical-center theme-img" [style.background-image]="selected?.type !== 'local' && selected?.url ? 'url(' + selected.url + ')' : ''" [style.width.px]="width" [style.height.px]="height">
            <ion-button class="selected-btn" size="small" shape="round" color="primary" *ngIf="selected?.url && selected?.type !== 'local'">
              <ion-icon class="font-20" slot="icon-only" name="checkmark-outline"></ion-icon>
            </ion-button>
            <!-- *ngIf="!selected?.url || selected?.type === 'local'" -->
            <ng-container>
              <ion-item class="upload-item background-transparent ion-no-margin ion-item-no-padding" color="grey" lines="none">
                <ion-label class="ion-text-center ion-margin">
                  <ion-img class="center upload-img" name="image-outline"></ion-img>
                  <div class="ion-text-center font-14">{{ 'WEBSITE.theme.cover.photo_upload' | translate }}</div>
                </ion-label>
              </ion-item>
            </ng-container>
          </div>
        </ion-card>
      </ion-col>
      <ion-col class="ion-align-self-center" *ngFor="let cover of coverList | slice : 0 : limit;">
        <ion-card class="theme-card box-shadow background-transparent ion-text-center" [style.width.px]="width" [style.height.px]="height" (click)="select(cover.mediaUrl)" *ngIf="cover?.mediaUrl?.url && cover?.mediaUrl?.type === 'local'" button>
          <div class="full-width-height vertical-center theme-img" [style.background-image]="'url(' + (cover?.thumbnailUrl?.url ? cover.thumbnailUrl.url : cover?.mediaUrl?.url) + ')'" [style.width.px]="width" [style.height.px]="height">
            <ion-button class="selected-btn font-14" size="small" shape="round" color="primary" *ngIf="cover?.mediaUrl?.url === selected?.url">
              <ion-icon class="font-20" slot="icon-only" name="checkmark-outline"></ion-icon>
            </ion-button>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll threshold="5%" (ionInfinite)="loadLimit($event)" *ngIf="coverList?.length > limit">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      [loadingText]="'LOADING.loading' | translate">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-footer>
  <ion-toolbar class="ion-padding-bottom">
    <ion-button expand="block" (click)="save(true)">
      {{ 'BTN.save' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
